import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { useEffect } from "react";
import MainScreen from "./screens/main/MainScreen";
import store from "./store";

const App = () => {
	// Force cache refresh for iOS WebView
	useEffect(() => {
		// Add a timestamp to force cache invalidation
		const timestamp = Date.now();
		const metaTag = document.createElement("meta");
		metaTag.setAttribute("name", "app-version");
		metaTag.setAttribute("content", timestamp.toString());
		document.head.appendChild(metaTag);

		// Log version for debugging
		console.log("App version:", timestamp);
	}, []);
	const router = createBrowserRouter([
		{
			path: "/",
			element: <MainScreen />,
		},
	]);

	return (
		<Provider store={store}>
			<RouterProvider router={router} />
		</Provider>
	);
};

export default App;
